'use client';

import React from 'react';

import { withEventScope } from '@repo/event-processor';
import { P1 } from '@repo/ui/components/Typography';

import Skeleton from './Skeleton';
import { Container, FlexRowCol } from './styles';
import { LayoutProps } from './types';

const skeletonRects = [
  { width: '322px', height: '22px' },
  { width: '128px', height: '22px' },
  { width: '133px', height: '22px' },
  { width: '210px', height: '22px' },
  { width: '183px', height: '22px' },
];

const GeneralLayout: React.FC<LayoutProps> = ({
  isLoading,
  text,
  renderCopyButton,
  renderLinkButton,
}) => {
  return (
    <Container direction="column">
      {isLoading ? <Skeleton rects={skeletonRects} /> : <P1>{text}</P1>}

      <FlexRowCol width="100%">
        {renderCopyButton()}
        {renderLinkButton()}
      </FlexRowCol>
    </Container>
  );
};

export default withEventScope(GeneralLayout, {
  module: 'generationResultCard',
});
